/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ImageKind = typeof ImageKind[keyof typeof ImageKind];


export const ImageKind = {
  covers: 'covers',
  avatars: 'avatars',
  categories: 'categories',
  collection_covers: 'collection_covers',
  collection_banners: 'collection_banners',
  banners: 'banners',
  emotion_icons: 'emotion_icons',
  emotion_images: 'emotion_images',
} as const;
